import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Optional, Output, Self, ViewChild } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { DataContextService } from '../../../services/datacontext.service';
import { SelectItemComponent } from './select-item/select-item.component';
export enum ErrorState {
  default = "default",
  focusOut = "focusOut"
}
@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.less']
})
export class SelectComponent implements OnInit, ControlValueAccessor {
  @Input() customClass: string;
  @Input() label: string;
  @Input() placeholder: string;
  @Input() isDisabled: boolean;
  @Input() value: any; 
  @Input() isRequired: boolean;
  @Input() isError:boolean= false;
  @Input() errorState: ErrorState = ErrorState.default;
  @Input() errorMessage: string;
  @Input() showStatus:boolean = false;
  @Input() customSelected:boolean = false;
  @Input() isButton:boolean = false;
  @Output() valueChanged: EventEmitter<any> = new EventEmitter();
  @Input() isContextMenu: boolean =false;
  @Output() previousItem:EventEmitter<any> = new EventEmitter();

  // Popup properties.
 heading:string;
  opened: boolean = false;
  
  onChange = (value: any) => {};
  onTouched = () => {};
  touched = false;

 

  get invalid(): boolean {
    if (!!this.ngControl) {
      return this.isError;
    }

    return this.ngControl ? this.ngControl.invalid : false;
  }

  get showError(): boolean {
    switch (this.errorState) {
      case ErrorState.default: {
        return this.invalid;
      }
      case ErrorState.focusOut: {
        if (!this.ngControl) {
          return false;
        }
        const { dirty, touched } = this.ngControl;
        return this.invalid ? dirty || touched : false;
      }
    }
  }

  get _value(): string {
    return this.value;
  }

  set _value(v: string) {
    if (v !== this.value) {
      this.value = v;
      this.change(this.value);
    }
  }

  constructor(@Self() @Optional() public ngControl: NgControl,
    private changeDetectorRef: ChangeDetectorRef,
    private dataContextService: DataContextService) {
    this.ngControl && (this.ngControl.valueAccessor = this);
  }

  ngOnInit() {
    this.changeDetectorRef.detectChanges();
  }
  
  change(value: string): void {
    this.value = value;
    this.onChange(value);
  }

  writeValue(value): void {
    if (!value) {
      this.placeholder = this.dataContextService.translateText('Translation.Select');
    }
    this.value = value;
    this.changeDetectorRef.detectChanges();
  }
  addSelectItem(value,heading,shortName){
    if(this.value == value){
      this.placeholder =shortName ? shortName :  heading
      this.change(value)
      this.changeDetectorRef.detectChanges();
    }
  }
 
  changeItem(value,heading,shortName){
    this.previousItem.emit(this.value)
    this.value = value;
    this.placeholder =shortName ? shortName :  heading;
    this.onChange(value)
    this.onTouched();
    this.valueChanged.emit(this.value);
  }
  registerOnChange(onChange: any): void {
    this.onChange = onChange;
  }
  toggleDropDown(event: MouseEvent): void {
    if (!this.isDisabled) {
      event.stopPropagation();
      this.opened = !this.opened;
    }
  }
  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

 

  setDisabledState(disabled: boolean): void {
    this.isDisabled = disabled;
  }
  close(): void {
    if (this.opened) {
      if (!this.touched) {
        this.onTouched();
        this.touched = true;
      }
      this.opened = false;
    }
  }
  
}
